import {scaffolderPlugin} from '@backstage/plugin-scaffolder';
import {createScaffolderFieldExtension} from '@backstage/plugin-scaffolder-react';
import {FormFieldBlueprint, createFormField} from '@backstage/plugin-scaffolder-react/alpha';
import {EmailField} from './EmailField';
import {schema} from './schema';

const emailFormField = createFormField({
  name: 'EmailExtension',
  component: EmailField as any,
  schema: schema as any,
});

export const EmailExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'EmailExtension',
    component: EmailField,
    schema,
  }),
);

export const emailFieldExtension = FormFieldBlueprint.make({
  name: 'email-extension',
  params: {
    field: async () => emailFormField,
  },
});
